import { Box } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { SliderCarousel } from '../../components/Carousel/SliderCarousel';
import { ProductGrid } from '../../components/ProductGrid/ProductGrid';
import { settingsAtom } from '../../atoms/Settings';
import { useIsMobile } from '../../hooks/useIsMobile';
import { Banners } from '../../components/Banner/Banners';
import { Brands } from '../../components/Brands/Brands';
import { DailyProducts } from '../../components/DailyProducts/DailyProducts';
import { Blogs } from '../../components/Blog/Blogs';
import { GenericHelmet } from '../../components/Helmet/GenericHelmet';
import { PopupSlot } from '../../components/Popup/PopupSlot';

export const Homepage = () => {
  const settings = useRecoilValue(settingsAtom);

  const isMobile = useIsMobile();

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        gap: 5,
      }}
    >
      <GenericHelmet
        title='Ana Sayfa'
        meta={{
          canonicalURL: '',
          description: settings.settingsV1.storefront_homepage_meta_description,
        }}
      />
      <PopupSlot isHomePage />

      {settings.settingsV1.slider_status === '1' && <SliderCarousel />}

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: 4.5,
          alignItems: 'center',
          boxSizing: 'border-box',
          px: isMobile ? 1.5 : 5,
        }}
      >
        {settings.settingsV1.popular_products_status === '1' && (
          <ProductGrid
            title={settings.settingsV1.popular_products_text}
            popularity='popular'
            titleStyle={
              settings.settingsV2?.popularProductsSettings?.titleStyle
            }
            dividerStyle={
              settings.settingsV2?.popularProductsSettings?.dividerStyle
            }
          />
        )}

        {settings.settingsV1.hightlights_status === '1' && (
          <ProductGrid
            title={settings.settingsV1.highlight_products}
            popularity='highlighted'
            titleStyle={
              settings.settingsV2?.highlightedProductsSettings?.titleStyle
            }
            dividerStyle={
              settings.settingsV2?.highlightedProductsSettings?.dividerStyle
            }
          />
        )}

        {settings.settingsV1.daily_products_status === '1' && <DailyProducts />}

        {settings.settingsV1.banner_status === '1' && <Banners />}

        {settings.settingsV1.brands_status === '1' && <Brands />}
      </Box>

      {settings.settingsV1.blogs_status === '1' && <Blogs />}
    </Box>
  );
};
